.Icon {
  flex: 0 0 1rem;
  width: 1rem;
  height: 1rem;
  fill: currentColor;
}
